import { getMemberId, getUserId, getSvocId } from '../utils/customer';
var memberId = getMemberId();
var userId = getUserId();
var svocId = getSvocId();
export var B2C_ACCOUNT_PATH = '/customer/account/v1';
export var B2B_ACCOUNT_PATH = '/b2b/user/account';
export var B2B_ACCOUNT_VIEW_PATH = '/b2b/account/view';
export var IMAGES_ASSETS_URL = 'https://assets.thdstatic.com/images/v1';
// B2C paths:
export var B2C_ACCOUNT_PATH_WITH_MEMBER_ID = "".concat(B2C_ACCOUNT_PATH, "/").concat(memberId);
export var B2C_ADDRESSES_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/addresses");
export var B2C_PAYMENTS_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/paymentcards");
var B2C_PAYPAL_BASE_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/paypal");
export var B2C_PAYPAL_INIT_PATH = "".concat(B2C_PAYPAL_BASE_PATH, "/initpaypal");
export var B2C_PAYPAL_SAVE_PATH = "".concat(B2C_PAYPAL_BASE_PATH, "/verifysavepaypal");
export var B2C_ACCOUNT_PROFILE_PATH = "".concat(B2C_ACCOUNT_PATH_WITH_MEMBER_ID, "/profile?checkPhoneEligibility=true");
// B2B paths:
export var B2B_ACCOUNT_PATH_WITH_USER_ID = "".concat(B2B_ACCOUNT_PATH, "/").concat(userId);
export var B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId);
export var B2B_ADDRESSES_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/addresses");
export var B2B_UPDATE_ADDRESES_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/addresses");
export var B2B_PAYMENTS_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/payment");
export var B2B_PAYMENTS_PATH_WITH_USER_ID = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/payment");
export var B2B_PAYMENTS_RETRIEVE_PATH = "".concat(B2B_PAYMENTS_PATH, "/retrieve");
export var B2B_UPDATE_PAYMENT_PATH = "".concat(B2B_PAYMENTS_PATH_WITH_USER_ID, "/update");
export var B2B_UPDATE_STATUS_PATH = "".concat(B2B_PAYMENTS_PATH_WITH_USER_ID, "/updatestatus");
export var B2B_ADD_UPDATE_NICKNAME_PATH = "".concat(B2B_PAYMENTS_PATH_WITH_USER_ID, "/addOrUpdateCardNickName");
export var B2B_BILLING_ADDRESS_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/billingAddress");
export var B2B_PAYPAL_SET_CHECKOUT_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/paypal/setExpressCheckout");
export var B2B_PAYPAL_SAVE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/paypal/savePayPalAccount");
export var B2B_STOP_ALL_AUTHORIZATION = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/payment/creditcard/stopPaa");
export var B2B_ACCOUNT_PROFILE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/profile");
export var B2B_ACCOUNT_CNP_ENROLLMENT = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/payment/creditcard/CNPEnrollmentRequest");
// B2B pages:
export var B2B_PURCHASE_HISTORY_PAGE = "".concat(B2B_ACCOUNT_VIEW_PATH, "/order/summary");
// Common paths:
export var ZIP_CODE_PATH = "".concat(B2B_ACCOUNT_PATH, "/zipCode");
export var OG_UPDATE_ADDRESS_QA_URL = 'https://staging.v2.ordergroove.com/customer/update_shipping_default';
export var OG_UPDATE_ADDRESS_PROD_URL = 'https://api.ordergroove.com/customer/update_shipping_default';
export var PROFILE_PAGE_PATH = '/myaccount/profile';
// Links for Home Depot Credit Cards page
export var B2B_CREDIT_CARDS_PAGE_URL = '/b2b/account/view/thdcreditcard';
export var B2C_CREDIT_CARDS_PAGE_URL = '/account/view/thdcreditcard';
